import { render, staticRenderFns } from "./PoiHubAdd.vue?vue&type=template&id=8261846c"
import script from "./PoiHubAdd.vue?vue&type=script&lang=js"
export * from "./PoiHubAdd.vue?vue&type=script&lang=js"
import style0 from "./PoiHubAdd.vue?vue&type=style&index=0&id=8261846c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports